import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { UpdateSetting, GetSetting, AddSetting, Upload } from "../../fetchs";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: "",
      keyHelper: "",
      title: "",
      desc: "",
      img: "",
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    const key = this.props.match.params.key;
    if (key) {
      this.loadSetting(key);
    }
  }

  handleSelectFile = (event) => {
    Upload(event.target.files[0], "goods")
      .then((response) => {
        return response.text();
      })

      .then((responseJson) => {
        this.setState({ img: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  loadSetting = (key) => {
    this.setState({ loading: true });
    GetSetting(key)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            key: responseJson.key,
            title: responseJson.title,
            desc: responseJson.desc,
            img: responseJson.img,
          });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  handleSave = () => {
    if (this.props.match.params.key) {
      UpdateSetting({
        key: this.state.key,
        title: this.state.title,
        desc: this.state.desc,
        img: this.state.img,
        id: this.props.match.params.key,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای ویرایش شدن تنظیمات");
          } else if (response.status === 200) {
            toast.success(" تنظیمات با موفقیت ویرایش شد");
            this.props.history.push("/main/settings");
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      AddSetting({
        key: this.state.key,
        title: this.state.title,
        desc: this.state.desc,
        img: this.state.img,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای اضافه شدن تنظیمات");
          } else if (response.status === 200) {
            toast.success(" تنظیمات با موفقیت اضافه شد");
            this.props.history.push("/main/settings");
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "key":
        this.setState({ key: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ keyHelper: "لطفا کلید را وارد کنید" });
        } else {
          this.setState({ keyHelper: "" });
        }
        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.key ? (
              <Typography component="h1" variant="h4" align="center">
                ویرایش تنظیمات
              </Typography>
            ) : (
              <Typography component="h1" variant="h4" align="center">
                افزودن تنظیمات جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={this.state.keyHelper.length !== 0}
                      helperText={this.state.keyHelper}
                      onChange={this.onchange}
                      id="key"
                      label="کلید"
                      required
                      fullWidth
                      // disabled={this.props.match.params.key ? true : false}
                      className={classes.textField}
                      value={this.state.key}
                      margin="normal"
                      InputLabelProps={
                        this.state.key.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.key.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-title"
                      label="عنوان"
                      fullWidth
                      className={classes.textField}
                      value={this.state.title}
                      onChange={this.handleChange("title")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <div>
                      <input
                        accept="image/*"
                        className={classes.input}
                        style={{ display: "none" }}
                        id="raised-button-file"
                        multiple
                        type="file"
                        onChange={this.handleSelectFile}
                      />
                      <label htmlFor="raised-button-file">
                        <Button
                          fullWidth
                          variant="contained"
                          component="span"
                          className={classes.button}
                        >
                          ارسال عکس
                        </Button>
                        {this.state.uploadPic && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </label>
                    </div>
                    <div>
                      <div className="picParent">
                        <img
                          src={`http://test.asa-oil.ir/${this.state.img}`}
                          className="picture"
                          alt={this.state.title}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-value"
                      label="توضیحات"
                      fullWidth
                      className={classes.textField}
                      value={this.state.desc}
                      onChange={this.handleChange("desc")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={
                        this.state.loading ||
                        this.state.keyHelper.length !== 0 ||
                        this.state.key.length === 0
                      }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

Setting.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Setting));
